import React from 'react';

const SmallButton = ({ children, ...props }) => (
  <button className='button button--small button--ghost' {...props}>
    {children}
  </button>
);

export default SmallButton;
